import { useMemo } from 'react'
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts'
import { getChartPalette } from '../../chartPalette'

const PALETTE = getChartPalette()
const toNum = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

const CycleFaultSummaryPieChart = ({ data = [] }) => {
  const pieData = useMemo(() => {
    return (data || [])
      .map((item) => ({
        name: `CF-${item.code}`,
        value: toNum(item.totalCf),
      }))
      .filter((item) => item.value > 0)
      .slice(0, 10)
  }, [data])

  const total = useMemo(() => pieData.reduce((acc, item) => acc + item.value, 0), [pieData])

  const chartData = useMemo(() => {
    if (total === 0) return [{ name: 'N/A', value: 1, isEmpty: true }]
    return pieData
  }, [pieData, total])

  const CustomLegend = ({ payload }) => {
    if (!payload || payload.length === 0) return null
    return (
      <div className="custom-legend-container">
        {payload.map((entry) => (
          <div className="legend-item" key={entry.value}>
            <span className="legend-color-dot" style={{ background: entry.color }} />
            <span className="legend-label">{entry.value}</span>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="cf-summary-pie-chart">
      <ResponsiveContainer width="100%" height={450}>
        <PieChart>
          <Pie data={chartData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={150} isAnimationActive={false} label>
            {chartData.map((entry, index) => (
              <Cell key={`${entry.name}-${index}`} fill={entry.isEmpty ? '#f0f0f0' : PALETTE[index % PALETTE.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend content={<CustomLegend />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export default CycleFaultSummaryPieChart
